import { useState } from 'react'
import Drawer from '@/common/components/Drawer.tsx'
import { Form } from '@/common/components/Form.tsx'
import { Input } from '@/common/components/Input.tsx'
import { WizardBodyContainer } from '@/app/pages/program_applications/vendor_application/components/WizardBodyContainer.tsx'
import { WizardFooter } from '@/app/pages/program_applications/vendor_application/components/WizardFooter.tsx'
import { WizardStepContent } from '@/app/pages/program_applications/vendor_application/components/WizardStepContent.tsx'
import { WizardStepTitle } from '@/app/pages/program_applications/vendor_application/components/WizardStepTitle.tsx'
import { useWizardContext } from '@/app/pages/program_applications/vendor_application/WizardProvider.tsx'
import { useTranslation } from 'react-i18next'

const StepId = 2 as const
export default function POCInfo() {
  const { t: translate } = useTranslation()
  const { setStepCompleted, goNext } = useWizardContext()
  const [drawerOpen, setDrawerOpen] = useState(false)
  const [showForm, setShowForm] = useState(false)
  const validateForm = () => {
    setStepCompleted(StepId)
    goNext()
  }
  return (
    <>
      <WizardBodyContainer>
        <WizardStepTitle>{translate('poc_information')}</WizardStepTitle>
        <WizardStepContent>
          <div className="sm:pl-20">
            <h3 className="p-2">
              {translate('primary_point_tetx')}
              <span
                className="cursor-pointer pl-2 text-primary font-regular hover:underline"
                onClick={() => setDrawerOpen(true)}
              >
                {translate('learn_more')}
              </span>
            </h3>
            <div className="pl-16 p-4">
              <div className="flex items-center gap-x-2 pb-2">
                <input
                  id="yes"
                  name="serviceLocations"
                  type="radio"
                  className="h-4 w-4 border-gray-500 text-primary-600 focus:ring-primary-600"
                  onChange={() => setShowForm(false)}
                />
                <label
                  htmlFor="yes"
                  className="block text-sm font-medium leading-6 mr-2"
                >
                  {translate('yes')}
                </label>
                <input
                  id="no"
                  name="serviceLocations"
                  type="radio"
                  className="h-4 w-4 border-gray-500 text-primary-600 focus:ring-primary-600"
                  onChange={() => setShowForm(true)}
                />
                <label
                  htmlFor="no"
                  className="block text-sm font-medium leading-6"
                >
                  No
                </label>
              </div>
            </div>
          </div>
          <div className="flex flex-col items-center flex-grow mt-8">
            <div className="w-full sm:w-1/2">
              {showForm && (
                <Form>
                  <div className="flex flex-col space-y-2">
                    <div>
                      <label
                        htmlFor="firstname"
                        className="block text-sm font-medium leading-6 text-gray-900"
                      >
                        {translate('poc_first_name')}
                        <span className="text-danger ml-1">*</span>
                      </label>
                      <div className="mt-1">
                        <Input
                          id="firstname"
                          name="firstname"
                          type="text"
                          autoComplete="given-name"
                          required
                        />
                      </div>
                    </div>
                    <div>
                      <label
                        htmlFor="lastname"
                        className="block text-sm font-medium leading-6 text-gray-900"
                      >
                        {translate('poc_last_name')}
                        <span className="text-danger ml-1">*</span>
                      </label>
                      <div className="mt-1">
                        <Input
                          id="lastname"
                          name="lastname"
                          type="text"
                          autoComplete="family-name"
                          required
                        />
                      </div>
                    </div>
                    <div>
                      <label
                        htmlFor="email"
                        className="block text-sm font-medium leading-6 text-gray-900"
                      >
                        {translate('poc_email')}
                        <span className="text-danger ml-1">*</span>
                      </label>
                      <div className="mt-1">
                        <Input
                          id="email"
                          name="email"
                          type="text"
                          autoComplete="email"
                          required
                        />
                      </div>
                    </div>
                    <div>
                      <label
                        htmlFor="phone"
                        className="text-sm font-medium leading-6 text-gray-900 flex items-center"
                      >
                        {translate('pos_phone_number')}
                        <span className="text-danger ml-1">*</span>
                      </label>
                      <div className="mt-1 flex rounded-md shadow-sm">
                        <select
                          id="country-code"
                          name="country-code"
                          className="rounded-l-md border-0 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary text-sm"
                          defaultValue="1"
                        >
                          <option value="1">{translate('us')}</option>
                          <option value="2">{translate('ca')}</option>
                        </select>
                        <div className="flex-grow">
                          <Input
                            id="phone"
                            name="phone"
                            type="tel"
                            autoComplete="tel"
                            required
                            placeholder="(123) 456-7890"
                            className="rounded-none rounded-r-md"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </div>
          </div>
        </WizardStepContent>
      </WizardBodyContainer>
      <WizardFooter onNext={validateForm} />
      <Drawer open={drawerOpen} setOpen={setDrawerOpen}>
        <h1 className="font-semibold text-gray-900 pt-12 pb-4">
          {translate('primary_organization_poc')}
        </h1>
        <p>{translate('understand_that_text')}</p>
      </Drawer>
    </>
  )
}
